import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../utils/withRouter";
import StaticHeader from "../static/common_components/staticHeader";
import StaticFooter from "../static/common_components/StaticFooter";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { v4 as uuidv4 } from "uuid";
import { getCmsContent_action, insertUpdateCmsMenu_action, deleteCmsMenu_action, insertUpdateCmsSubheader_action } from "../../actions/cms_action/cmsAction";
import { toastError, toastSuccess } from "../../utils/constants";
import { ToastContainer } from "react-toastify";
import { Tab, Nav } from "react-bootstrap";

class cmsHeaderMaster extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuList: [],
            isLoading: false,
            cmsMenuData: [],
            cmsFooterData: [],
            cmsSubheaderData: [],
            editingRowId: null
        };
    }

    componentDidMount() {
        this.getCmsContent();
    }
    handleEdit = (tableId) => {
        this.setState({ editingRowId: tableId });
    };

    handleChange = (e, key, value) => {
        const { cmsSubheaderData, editingRowId } = this.state;
        const updatedData = cmsSubheaderData.map((row) => {
            if ((row.tableId || row.SubheaderID) === editingRowId) {
                return { ...row, [key]: value !== undefined ? value : e.target.value };
            }
            return row;
        });
        this.setState({ cmsSubheaderData: updatedData });
    };
    handleAddRow = (tableId) => {
        const { cmsSubheaderData } = this.state;
        const index = cmsSubheaderData.findIndex(row => (row.tableId || row.SubheaderID) === tableId);

        const newRow = {
            tableId: Date.now(),
            SubheaderID: null,
            SubheaderName: "",
            ViewType: "",
            SocialType: "",
            Link: "",
            isActive: false,
            isPublish: false
        };

        const updatedData = [...cmsSubheaderData.slice(0, index + 1), newRow, ...cmsSubheaderData.slice(index + 1)];
        this.setState({ cmsSubheaderData: updatedData, editingRowId: newRow.tableId });
    };
    async getCmsContent() {
        try {
            this.setState({ isLoading: true });

            const data = await this.props.getCmsContent_action(1, 'home');
            const cmsSubheaderData = data?.data[4] !== "" ? data?.data[4] : []

            if (data.error !== 1) {
                const flatList = data?.data?.[1] || [];

                const menuMap = {};
                flatList.forEach(item => {
                    item.id = uuidv4();
                    item.children = [];
                    item.showSave = false;
                    menuMap[item.MenuID] = item;
                });

                const rootMenus = [];
                flatList.forEach(item => {
                    if (item.ParentID) {
                        if (menuMap[item.ParentID]) {
                            menuMap[item.ParentID].children.push(item);
                        }
                    } else {
                        rootMenus.push(item);
                    }
                });

                this.setState({
                    isLoading: false,
                    cmsMenuData: data?.data?.[1],
                    cmsFooterData: data?.data?.[2][0],
                    cmsSubheaderData: cmsSubheaderData,
                    menuList: rootMenus,
                });
            } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }

    handleInputChange = (id, field, value, parent = null) => {
        console.error(id, field, value, parent, 'changeeeeeee')
        // Prevent spaces in URL field
        if (field === 'Url') {
            value = value.replace(/\s/g, '');
        }

        const updateMenus = (menus) =>
            menus.map(menu => {
                if (menu.id === id) {
                    return { ...menu, [field]: value, showSave: true };
                } else if (menu.children) {
                    return {
                        ...menu,
                        children: updateMenus(menu.children)
                    };
                }
                return menu;
            });

        this.setState(prev => ({
            menuList: updateMenus(prev.menuList)
        }));
    };

    saveRowLocally = (id) => {
        const updateMenus = (menus) =>
            menus.map(menu => {
                if (menu.id === id) {
                    const title = menu.Title?.trim();
                    const url = menu.URL?.trim();

                    if (!title || !url) {
                        toastError('Both Title and URL are required.');
                        return menu; // Do not update showSave if validation fails
                    }

                    return { ...menu, showSave: false };
                } else if (menu.children) {
                    return {
                        ...menu,
                        children: updateMenus(menu.children)
                    };
                }
                return menu;
            });

        this.setState(prev => ({
            menuList: updateMenus(prev.menuList)
        }, () => {
            this.submitMenu()
        }));
    };

    addNewMenu = (parentId = null) => {
        const { menuList } = this.state;

        if (!parentId) {
            // Adding a new parent menu
            const maxSequence = menuList.reduce((max, item) => Math.max(max, item.Sequence || 0), 0);
            const newMenu = {
                id: menuList.length,  // Use the index of the menuList as the id
                MenuID: null,
                ParentID: null,
                Title: "",
                Url: "",
                Sequence: maxSequence + 1,
                isActive: true,
                isPublish: true,
                isMenuItem: true,
                children: [],
                showSave: true, id: uuidv4()
            };
            this.setState(prev => ({
                menuList: [...prev.menuList, newMenu],
            }));
        } else {
            // Adding a new child menu
            const updatedList = menuList.map(menu => {
                if (menu.id === parentId) {
                    const children = menu.children || [];
                    const maxChildSequence = children.reduce((max, item) => Math.max(max, item.Sequence || 0), 0);
                    const newChild = {
                        id: uuidv4(),
                        MenuID: null,
                        ParentID: parentId,
                        Title: "",
                        Url: "",
                        Sequence: maxChildSequence + 1,
                        isActive: true,
                        isPublish: true,
                        isMenuItem: true,
                        children: [],
                        showSave: true,
                    };
                    return {
                        ...menu,
                        children: [...children, newChild],
                    };
                }
                return menu;
            });
            this.setState({ menuList: updatedList });
        }
    };

    handleRemove = (menu, parent = null) => {
        if (menu.MenuID) {
            this.setState((prevState) => {
                const updatedList = prevState.menuList.map((item) => {
                    if (item.id === menu.id) {
                        return { ...item, isActive: false };
                    } else if (item.children) {
                        return {
                            ...item,
                            children: item.children.map((child) =>
                                child.id === menu.id ? { ...child, isActive: false } : child
                            ),
                        };
                    }
                    return item;
                });
                return { menuList: updatedList };
            });
        } else {
            this.setState((prevState) => {
                let updatedList = [...prevState.menuList];
                if (parent) {
                    updatedList = updatedList.map((item) => {
                        if (item.id === parent.id) {
                            return {
                                ...item,
                                children: item.children.filter((child) => child.id !== menu.id),
                            };
                        }
                        return item;
                    });
                } else {
                    updatedList = updatedList.filter((item) => item.id !== menu.id);
                }
                return { menuList: updatedList };
            });
        }
    };
    async deleteCmsMenu(menu, parent = null) {
        if (menu.MenuID) {
            try {
                this.setState({ isLoading: true });
                const isConfirm = window.confirm('Are you sure you want to remove this Menu?')
                if (isConfirm) {
                    const data = await this.props.deleteCmsMenu_action(menu.MenuID);

                    if (data.error !== 1) {
                        this.setState({ isLoading: false });
                        if (data.data !== "") {
                            toastSuccess(`Menu Deleted Successfully`)
                            this.getCmsContent();
                        }
                    } else {
                        this.setState({ isLoading: false });
                        toastError(data.msg);
                    }
                }
            } catch (err) {
                console.error(err);
                this.setState({ isLoading: false });
            }
        } else {
            this.setState((prevState) => {
                let updatedList = [...prevState.menuList];
                if (parent) {
                    updatedList = updatedList.map((item) => {
                        if (item.id === parent.id) {
                            return {
                                ...item,
                                children: item.children.filter((child) => child.id !== menu.id),
                            };
                        }
                        return item;
                    });
                } else {
                    updatedList = updatedList.filter((item) => item.id !== menu.id);
                }
                return { menuList: updatedList };
            });
        }
    }

    onDragEnd = result => {
        const { source, destination, type } = result;
        if (!destination) return;

        if (type === "PARENT") {
            const items = Array.from(this.state.menuList);
            const [reorderedItem] = items.splice(source.index, 1);
            items.splice(destination.index, 0, reorderedItem);

            const updatedWithSequence = items.map((item, index) => ({
                ...item,
                Sequence: index + 1,
            }));

            this.setState({ menuList: updatedWithSequence });

        } else {
            const parentId = type;
            const parent = this.state.menuList.find(menu => menu.id === parentId);
            const items = Array.from(parent.children);
            const [reorderedChild] = items.splice(source.index, 1);
            items.splice(destination.index, 0, reorderedChild);

            const updatedChildren = items.map((child, index) => ({
                ...child,
                Sequence: index + 1,
            }));

            const updatedList = this.state.menuList.map(menu =>
                menu.id === parentId ? { ...menu, children: updatedChildren } : menu
            );

            this.setState({ menuList: updatedList });
        }
    };

    renderMenuRow = (menu, index, parent = null) => {
        const isChild = !!parent;
        const isparent = menu == parent ? 1 : 0
        return (
            <Draggable key={menu.id} draggableId={menu.id.toString()} index={index}>
                {(provided) => (
                    <tr
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        style={{ ...provided.draggableProps.style, backgroundColor: isChild ? "#f5f5f5" : isparent == 1 ? "#eee" : "white" }}
                    >
                        {/* <td>{menu.MenuID || "-"}</td>
                        <td>{menu.ParentID || "-"}</td> */}
                        <td style={{ width: '470px' }}>
                            <input style={{ width: '100%' }}
                                type="text"
                                className="form-control"
                                value={menu.Title}
                                onChange={(e) => this.handleInputChange(menu.id, "Title", e.target.value, parent)}
                            />
                        </td>
                        <td style={{ width: '450px' }}>
                            <input
                                type="text"
                                className="form-control"
                                value={menu.Url}
                                onChange={(e) => this.handleInputChange(menu.id, "Url", e.target.value, parent)}
                            />
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            {`${parent?.Sequence ? parent.Sequence + '.' : ''}${menu.Sequence}`}
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            <input
                                type="checkbox"
                                checked={menu.isActive}
                                onChange={() => this.handleInputChange(menu.id, "isActive", !menu.isActive, parent)}
                            />
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            <input
                                type="checkbox"
                                checked={menu.isPublish}
                                onChange={() => this.handleInputChange(menu.id, "isPublish", !menu.isPublish, parent)}
                            />
                        </td>
                        <td className="text-center" style={{ width: '100px' }}>
                            <input
                                type="checkbox"
                                checked={menu.isMenuItem}
                                onChange={() => this.handleInputChange(menu.id, "isMenuItem", !menu.isMenuItem, parent)}
                            />
                        </td>
                        <td className="text-right" style={{ width: '100px' }}>
                            {!isChild && (
                                <button className="btn btn-sm btn-outline-success mr-2 " onClick={() => this.addNewMenu(menu.id)}>+</button>
                            )}
                            <button className="btn btn-sm btn-outline-danger  ml-2" onClick={() => this.deleteCmsMenu(menu, parent)}><i class="fa fa-trash-o"></i></button>
                            {/* {menu.showSave && (
                                <button className="btn btn-sm btn-outline-primary" onClick={() => this.saveRowLocally(menu.id)}>Save</button>
                            )} */}
                        </td>
                    </tr>
                )}
            </Draggable>
        );
    };
    submitSubmenu = async () => {
        const { cmsSubheaderData, editingRowId } = this.state;
        const selectedRow = cmsSubheaderData.find(row => (row.tableId || row.SubheaderID) === editingRowId);

        if (!selectedRow.SubheaderName) {
            toastError("Please Enter Name");
            return;
        }
        if (!selectedRow.ViewType) {
            toastError("Please Select View Type");
            return;
        }
        if (selectedRow.ViewType === "SM" && !selectedRow.SocialType) {
            toastError("Please Select Social Type");
            return;
        }
        if (!selectedRow.Link) {
            toastError("Please Provide Link");
            return;
        }

        try {
            this.setState({ isLoading: true });
            const data = await this.props.insertUpdateCmsSubheader_action(
                selectedRow.SubheaderID,
                selectedRow.SubheaderName,
                selectedRow.ViewType,
                selectedRow.SocialType,
                selectedRow.Link,
                selectedRow.isActive,
                selectedRow.isPublish
            );

            this.setState({ isLoading: false, editingRowId: null });

            if (data.error !== 1) {
                toastSuccess("Sub Menu Added Successfully");
                this.getCmsContent();
            } else {
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    };
    async submitMenu() {
        try {
            const { menuList } = this.state;
            this.setState({ isLoading: true });

            const flatMenuList = [];

            for (const parent of menuList) {
                const { children, ...parentData } = parent;

                const hasInvalidParent = !parentData.Title?.trim() || !parentData.Url?.trim();
                if (hasInvalidParent) {
                    toastError('Kindly Enter Title and Url in all Menu');
                    this.setState({ isLoading: false });
                    return;
                }

                const parentMenuID = parentData.MenuID || null;

                flatMenuList.push({
                    MenuID: parentMenuID,
                    ParentID: null,
                    Title: parentData.Title,
                    Url: parentData.Url,
                    Sequence: parentData.Sequence,
                    isActive: parentData.isActive,
                    isPublish: parentData.isPublish,
                    isMenuItem: parentData.isMenuItem
                });

                if (Array.isArray(children)) {
                    for (const child of children) {
                        const hasInvalidChild = !child.Title?.trim() || !child.Url?.trim();
                        if (hasInvalidChild) {
                            toastError('Kindly Enter Title and Url in all Menu');
                            this.setState({ isLoading: false });
                            return;
                        }

                        flatMenuList.push({
                            MenuID: child.MenuID || null,
                            ParentID: parentMenuID,
                            Title: child.Title,
                            Url: child.Url,
                            Sequence: child.Sequence,
                            isActive: child.isActive,
                            isPublish: child.isPublish,
                            isMenuItem: child.isMenuItem
                        });
                    }
                }
            }

            const data = await this.props.insertUpdateCmsMenu_action(flatMenuList);

            this.setState({ isLoading: false });

            if (data.error !== 1) {
                toastSuccess('Menu Added Successfully');
                this.getCmsContent();
            } else {
                toastError(data.msg);
            }
        } catch (err) {
            console.error(err);
            this.setState({ isLoading: false });
        }
    }


    render() {
        const { menuList, cmsMenuData, cmsFooterData, cmsSubheaderData, } = this.state;

        return (
            <main id="main">
                <ToastContainer />
                <StaticHeader headerNavs={cmsMenuData} />
                <section style={{ paddingTop: '10rem' }}>
                    <div className="container-fluid">
                        <div  style={{ paddingLeft: '0px' }}>
                            {/* Heading with 0 bottom margin for tight alignment */}
                            <div>
                                <h2
                                    className="dashboard-tit py-0 blog-name"
                                    style={{
                                        marginBottom: '5px',
                                        paddingLeft: '0px',
                                        fontWeight: '600',
                                        fontSize: '28px'
                                    }}
                                >
                                    CMS Menu Master
                                </h2>
                                <div>
                                    <Tab.Container defaultActiveKey="Main">
                                        {/* Nav container with 0 left padding to align with H2 */}
                                        <Nav
                                            variant="tabs"
                                            className="nav nav-tabs nav-tabs-custom nav-success mb-3 myOrderTabs"
                                            role="tablist"
                                            style={{
                                                paddingLeft: '0px',
                                                marginLeft: '0px',
                                                borderBottom: '2px solid #f3f3f3'
                                            }}
                                        >
                                            <Nav.Item className="tabs-border">
                                                <Nav.Link
                                                    eventKey="Main"
                                                    className="tabs-color"
                                                    style={{
                                                        paddingLeft: '0px',
                                                        paddingRight: '20px',
                                                        border: 'none',
                                                        background: 'transparent'
                                                    }}
                                                >
                                                    Main Menu
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className="tabs-border">
                                                <Nav.Link
                                                    eventKey="Sub"
                                                    className="tabs-color"
                                                    style={{
                                                        paddingLeft: '20px',
                                                        paddingRight: '20px',
                                                        border: 'none',
                                                        background: 'transparent'
                                                    }}
                                                >
                                                    Sub Menu
                                                </Nav.Link>
                                            </Nav.Item>
                                        </Nav>

                                        <Tab.Content className="edit-award-rofile-body pr-1" style={{ paddingTop: '10px' }}>
                                            <Tab.Pane eventKey="Main">
                                                <div style={{ marginBottom: '15px' }}>
                                                    <button className="btn btn-primary me-2 p-1 px-2" onClick={() => this.submitMenu()}>Submit Menu</button>
                                                    <button className="btn btn-success p-1 px-2" onClick={() => this.addNewMenu()}>Add Menu</button>
                                                </div>

                                                <table className="table table-bordered">
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '425px' }}>Title</th>
                                                            <th style={{ width: '425px' }}>URL</th>
                                                            <th className="text-center" style={{ width: '100px' }}>Sequence</th>
                                                            <th className="text-center" style={{ width: '100px' }}>Active</th>
                                                            <th className="text-center" style={{ width: '100px' }}>Publish</th>
                                                            <th className="text-center" style={{ width: '100px' }}>Menu Item</th>
                                                            <th className="text-right" style={{ width: '100px' }}>Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <DragDropContext onDragEnd={this.onDragEnd}>
                                                        <Droppable droppableId="menuList" type="PARENT">
                                                            {(provided) => (
                                                                <tbody ref={provided.innerRef} {...provided.droppableProps}>
                                                                    {menuList.length > 0 ? menuList?.sort((a, b) => a.Sequence - b.Sequence)?.map((menu, index) => (
                                                                        <React.Fragment key={menu.id}>
                                                                            {this.renderMenuRow(menu, index)}
                                                                            {menu.children && menu.children.length > 0 && (
                                                                                <Droppable droppableId={menu.id} type={menu.id}>
                                                                                    {(providedChild) => (
                                                                                        <tr>
                                                                                            <td className="pr-0" colSpan="7" style={{ paddingLeft: '2rem', background: '#f9f9f9' }}>
                                                                                                <table className="table mb-0">
                                                                                                    <tbody ref={providedChild.innerRef} {...providedChild.droppableProps}>
                                                                                                        {menu.children?.sort((a, b) => a.Sequence - b.Sequence).map((child, childIndex) =>
                                                                                                            this.renderMenuRow(child, childIndex, menu)
                                                                                                        )}
                                                                                                        {providedChild.placeholder}
                                                                                                    </tbody>
                                                                                                </table>
                                                                                            </td>
                                                                                        </tr>
                                                                                    )}
                                                                                </Droppable>
                                                                            )}
                                                                        </React.Fragment>
                                                                    )) : (
                                                                        <tr>
                                                                            <td className="text-center" colSpan={7}>No Menu Available</td>
                                                                        </tr>
                                                                    )}
                                                                    {provided.placeholder}
                                                                </tbody>
                                                            )}
                                                        </Droppable>
                                                    </DragDropContext>
                                                </table>
                                                <div style={{ marginTop: '20px' }}>
                                                    <button className="btn btn-outline-primary" onClick={() => this.submitMenu()}>Submit Menu</button>
                                                    <button className="btn btn-outline-success mx-2" onClick={() => this.addNewMenu()}>Add Menu</button>
                                                </div>
                                            </Tab.Pane>

                                            <Tab.Pane eventKey="Sub">
                                                <div className="container-fluid p-0">
                                                    <table className="table table-bordered">
                                                        <thead>
                                                            <tr>
                                                                <th style={{ width: '400px' }}>Name</th>
                                                                <th style={{ width: '300px' }}>View Type</th>
                                                                <th className="text-center" style={{ width: '300px' }}>Social Type</th>
                                                                <th className="text-center" style={{ width: '400px' }}>Link</th>
                                                                <th className="text-center" style={{ width: '100px' }}>Active</th>
                                                                <th className="text-center" style={{ width: '100px' }}>Publish</th>
                                                                <th className="text-right" style={{ width: '120px' }}>Actions</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {cmsSubheaderData.length > 0 ? cmsSubheaderData.map((data) => (
                                                                <tr key={data.tableId || data.SubheaderID}>
                                                                    <td>
                                                                        {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                            <input type="text" className="form-control" value={data.SubheaderName} onChange={(e) => this.handleChange(e, "SubheaderName")} />
                                                                        ) : (
                                                                            <span>{data.SubheaderName}</span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                            <select className="form-control" onChange={(e) => this.handleChange(e, "ViewType")} value={data.ViewType}>
                                                                                <option value=""></option>
                                                                                <option value="SM">Social Media</option>
                                                                                <option value="BTN">Button</option>
                                                                            </select>
                                                                        ) : (
                                                                            <span>{data.ViewType}</span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                            <select className="form-control" disabled={data.ViewType === "BTN"} onChange={(e) => this.handleChange(e, "SocialType")} value={data.SocialType}>
                                                                                <option value=""></option>
                                                                                <option value="Email">Email</option>
                                                                                <option value="Phone">Phone</option>
                                                                                <option value="Facebook">Facebook</option>
                                                                                <option value="LinkedIn">LinkedIn</option>
                                                                                <option value="Twitter">Twitter</option>
                                                                                <option value="Instagram">Instagram</option>
                                                                            </select>
                                                                        ) : (
                                                                            <span>{data.SocialType}</span>
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {this.state.editingRowId === (data.tableId || data.SubheaderID) ? (
                                                                            <input type="text" className="form-control" value={data.Link} onChange={(e) => this.handleChange(e, "Link")} />
                                                                        ) : (
                                                                            <span>{data.Link}</span>
                                                                        )}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={data.isActive}
                                                                            disabled={this.state.editingRowId !== (data.tableId || data.SubheaderID)}
                                                                            onChange={(e) => this.handleChange(e, "isActive", e.target.checked)}
                                                                        />
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={data.isPublish}
                                                                            disabled={this.state.editingRowId !== (data.tableId || data.SubheaderID)}
                                                                            onChange={(e) => this.handleChange(e, "isPublish", e.target.checked)}
                                                                        />
                                                                    </td>
                                                                    <td className="text-right">
                                                                        <i className="far fa-edit mx-1" style={{ cursor: 'pointer' }} onClick={() => this.handleEdit(data.tableId || data.SubheaderID)} />
                                                                        <i className="far fa-plus-square mx-1" style={{ cursor: 'pointer' }} onClick={() => this.handleAddRow(data.tableId || data.SubheaderID)} />
                                                                        <i className="far fa-save mx-1" style={{ cursor: 'pointer', color: 'green' }} onClick={() => this.submitSubmenu()} />
                                                                    </td>
                                                                </tr>
                                                            )) : (
                                                                <tr><td className="text-center" colSpan={7}>No Record Found</td></tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </Tab.Container>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <StaticFooter footerData={cmsFooterData} />
            </main>
        );
    }
}

export default withRouter(connect(null, { getCmsContent_action, insertUpdateCmsMenu_action, deleteCmsMenu_action, insertUpdateCmsSubheader_action })(cmsHeaderMaster));
